import { render } from "./MediathequePosteVideo.vue?vue&type=template&id=78f568f8&scoped=true&ts=true"
import script from "./MediathequePosteVideo.vue?vue&type=script&lang=ts"
export * from "./MediathequePosteVideo.vue?vue&type=script&lang=ts"

import "./MediathequePosteVideo.vue?vue&type=style&index=0&id=78f568f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f568f8"]])

export default __exports__